import { Injectable } from "@angular/core";
import { _HttpClient } from "@delon/theme";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DeferredVatLookupService {
    isDeferredVatActive:boolean =false;

    constructor(private http:_HttpClient){}

    loadDeferredVatSettings(): Observable<boolean> {
      return this.http.get<boolean>('api/SystemData/GetDeferredVatDefaultSettings');
    }

}